import { getLocale } from '@advanza/func/locale'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const sharedLocaleModules = import.meta.glob<{ default: Record<string, unknown> }>(
    '../../shared/locales/*/*.json',
)

function loadSharedLocale(lng: string) {
    const moduleKey = `../../shared/locales/${lng}/shared.json`
    const loader = sharedLocaleModules[moduleKey]

    if (!loader) {
        return Promise.reject(new Error(`Shared locale not found: ${lng}`))
    }

    return loader()
}

i18n.use(initReactI18next).init({
    fallbackLng: 'nl',
    lng: getLocale(),
    ns: ['shared'],
    defaultNS: 'shared',
    interpolation: {
        escapeValue: false,
    },
    resources: {},
    react: {
        useSuspense: false,
    },
})

function addSharedBundle(lng: string, resources: { default?: Record<string, unknown> }) {
    i18n.addResourceBundle(lng, 'shared', resources.default ?? resources)
}

const locale = getLocale()

loadSharedLocale(locale)
    .then((resources) => addSharedBundle(locale, resources))
    .catch((error) => {
        if (locale === 'nl') {
            console.error('Failed to load shared i18n for office', error)
            return
        }
        loadSharedLocale('nl')
            .then((resources) => addSharedBundle('nl', resources))
            .catch((fallbackError) => {
                console.error('Failed to load shared i18n for office', fallbackError)
            })
    })

export default i18n
